module.exports = __webpack_public_path__ + "img/list_7.75c397ad.png";